module.exports = __webpack_public_path__ + "img/3.0048d5a3.png";